<template>
  <van-tabbar v-model="active" active-color="#ff6602" id="app_tab">
    <van-tabbar-item
      v-for="(item,index) in navList"
      :key="index"
      @click="navClick(item)"
    >
      <span>{{item.title}}</span>
      <img
        slot="icon"
        slot-scope="props"
        :src="props.active ? navIcon[item.icon].act : navIcon[item.icon].nor"
      />
      <!-- <i slot="icon" class="iconfont fs18" :class="item.icon"></i> -->
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import icon from "@/assets/img/tab/index.js";
export default {
  data() {
    return {
      active: null,
      navIcon: icon,
      navList: [
        {
          title: "首页",
          icon: "sy",
          routeName: "home"
        },
        {
          title: "分类",
          icon: "fl",
          routeName: "serviceType"
        },
        {
          title: "订单",
          icon: "dd",
          routeName: "orderList"
        },
        {
          title: "我的",
          icon: "wd",
          routeName: "my"
        }
      ]
    };
  },
  created() {
    this.changeNav(this.$route);
  },
  components: {},
  computed: {},
  watch: {
    $route(route) {
      this.changeNav(route);
    }
  },
  methods: {
    changeNav(route) {
      let _index = this.navList.findIndex(item => item.routeName == route.name);
      this.active = _index === -1 ? null : _index;
    },
    navClick(item) {
      this.$router.push({ name: item.routeName });
    }
  }
};
</script>

<style lang="scss">
// app_tab
#app_tab {
  font-size: 3.3vw;
  $padding: 1em;
  &.van-tabbar {
    height: 4.3em;
    box-shadow: 0 -0.5vw 2.5vw -1vw rgba(0, 0, 0, 0.5);
    .van-tabbar-item {
      color: rgba(177, 177, 177, 1);
      font-size: inherit;
      padding-bottom: 1vw;
      .van-tabbar-item__icon {
        font-size: 1.2em;
        margin-bottom: 0.8vw;
        img {
          width: 2em;
          height: 2em;
        }
      }
      .van-tabbar-item__text {
        font-size: 1em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/tabBar.vue